import type {AhpSpaceSelection} from '@github-ui/ahp-session-client/contracts'
import {useFetchCopilotSpace} from '@github-ui/copilot-spaces/hooks'
import {SPACE_CHAT_PARAM, spaceIdFromOwnerAndId} from '@github-ui/copilot-chat-helpers/custom-copilots-helpers'
import {useSearchParams} from '@github-ui/use-navigate'

/**
 * Resolves the `?space=owner/id` param written by the Spaces list "Start chat" action into the
 * full selection the composer needs, since the list only knows the owner and id.
 */
export function useChatSpaceParam(): {space: AhpSpaceSelection | undefined; failed: boolean} {
  const [searchParams] = useSearchParams()
  const param = searchParams.get(SPACE_CHAT_PARAM)
  const spaceId = spaceIdFromOwnerAndId(param)
  const {data, isError} = useFetchCopilotSpace(spaceId ?? null)

  // A param that never parsed is as much a failure to attach as a rejected lookup.
  const failed = Boolean(param) && (!spaceId || isError)
  const space: AhpSpaceSelection | undefined = data
    ? {id: data.id, owner: data.owner, slug: data.slug, name: data.name}
    : undefined

  return {space, failed}
}
